import { useEffect, useRef } from "react";

const SDK_SRC =
  "https://www.paypal.com/sdk/js?client-id=BAAKM21E-Qfv5lMTl5gIzqbKz8QvQ3nqEmPRaekuUB0qz2S-Cp3Uzral4r55MCGqJNPcaXNjN17lugTkwA&components=hosted-buttons&disable-funding=venmo&currency=EUR";
const HOSTED_BUTTON_ID = "SY97Z693TLPHC";

let sdkPromise;
function loadHostedButtonsSdk() {
  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      if (window.paypal?.HostedButtons) return resolve(window.paypal);
      const s = document.createElement("script");
      s.src = SDK_SRC;
      s.async = true;
      s.onload = () => resolve(window.paypal);
      s.onerror = () => reject(new Error("paypal-sdk"));
      document.body.appendChild(s);
    });
  }
  return sdkPromise;
}

const PayPalHostedButton = ({ testid = "paypal-hosted-button" }) => {
  const ref = useRef(null);

  useEffect(() => {
    let cancelled = false;
    loadHostedButtonsSdk()
      .then((paypal) => {
        if (cancelled || !ref.current || !paypal?.HostedButtons) return;
        ref.current.innerHTML = "";
        paypal.HostedButtons({ hostedButtonId: HOSTED_BUTTON_ID }).render(ref.current);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="paypal-hosted-button-wrapper min-h-[48px] w-full"
    />
  );
};

export default PayPalHostedButton;
